import { getLogger } from "@expert/logging";
import type { ServiceProvider } from "@expert/service-providers";
import { getFeature } from "@soluto-private/expert-workspace-feature-flagging";
import { useQuery } from "@tanstack/react-query";
import type { KyInstance } from "ky";
import type { AppConfig } from "../types";

const logger = getLogger({ module: "useAppConfigAndServiceProviderOverride" });
/** Can ONLY be used under the <AuthProvider> scope
 * Retrieves the app configuration (currently specific for service provider, like TwilioAppConfig)
 */
export const useAppConfigAndServiceProviderOverride = (api: KyInstance, employeeId: string | undefined) => {
    const { data, isLoading, error } = useQuery({
        queryKey: [`app-config`],
        queryFn: async () =>
            Promise.all([
                api.get("api/app-config").json<AppConfig>(),
                getFeature<readonly ServiceProvider[]>("ServiceProvidersOverride", { employeeId }),
            ]),
        retry: 0,
        refetchOnWindowFocus: false,
        enabled: !!employeeId,
    });
    if (data) {
        logger.debug("AppConfig received");
    }
    if (error) {
        logger.error(error, "Failed to fetch App Configuration");
    }
    return { data, isLoading, error };
};
